import type { UploadFileItem } from "@/components/upload";

export type FeedbackWidgetValue = "bug" | "feedback";

export type FeedbackWidgetCancelDetail = {
  feedbackType: FeedbackWidgetValue | null;
};

export type FeedbackWidgetCloseDetail = {
  feedbackType: FeedbackWidgetValue | null;
};

export type FeedbackWidgetSubmitDetail = {
  feedback: string;
  feedbackType: string;
  screenshots?: UploadFileItem[];
  title?: string;
};

export interface FeedbackSubtype {
  label: string;
  placeholder: string;
  textLabel: string;
  value: string;
}

export interface Option {
  description: string;
  icon: string;
  label: string;
  value: FeedbackWidgetValue;
}

export const FEEDBACK_SUBTYPES: FeedbackSubtype[] = [
  {
    label: "Suggestion",
    placeholder: "Write your suggestion...",
    textLabel: "Your suggestion",
    value: "suggestion",
  },
  {
    label: "Compliment",
    placeholder: "Write your compliment...",
    textLabel: "Your compliment",
    value: "compliment",
  },
  {
    label: "General",
    placeholder: "Write your feedback...",
    textLabel: "Your feedback",
    value: "general",
  },
];

export const OPTIONS: Option[] = [
  {
    description: "Something's not working right",
    icon: "alert-triangle",
    label: "Report a bug",
    value: "bug",
  },
  {
    description: "Suggestions and comments",
    icon: "message-text-square-01",
    label: "Provide feedback",
    value: "feedback",
  },
];
